import React from "react"

export default function GridLayout({ children }) {
  return (
    <div className="max-w-7xl mx-auto grid gap-5 grid-cols-1 lg:grid-cols-2">
      {children}
    </div>
  )
}
